"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var CarouselSlideDot =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CarouselSlideDot, _Component);

  function CarouselSlideDot() {
    var _getPrototypeOf2, _context;

    var _this;

    (0, _classCallCheck2.default)(this, CarouselSlideDot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CarouselSlideDot)).call.apply(_getPrototypeOf2, (0, _concat.default)(_context = [this]).call(_context, args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onDotClick", function () {
      var _this$props = _this.props,
          dotIndex = _this$props.dotIndex,
          onDotClick = _this$props.onDotClick;

      if (onDotClick) {
        onDotClick(dotIndex);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(CarouselSlideDot, [{
    key: "render",
    value: function render() {
      var isDotSelected = this.props.isDotSelected;
      var classes = (0, _classnames.default)('CarouselDot', {
        'CarouselDot-selected': isDotSelected
      });
      return _react.default.createElement(_Button.default, {
        className: classes,
        onClick: this._onDotClick
      });
    }
  }]);
  return CarouselSlideDot;
}(_react.Component);

exports.default = CarouselSlideDot;